<script lang="ts">
    import Page from '$lib/components/Page.svelte';

    // Types
    import type { Page as PageType } from '$lib/types/Page';

    export let data: PageType;
</script>

<Page pageData={data} />
